/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { LogProvider } from './Interfaces';

/**
 * Logging function
 */
export type LogFunc = (msg: string) => void;

/**
 * Simple logger
 */
export class Logger {
    public constructor(private name, private logger: LogProvider) {}

    public debug(message: string) {
        this.logger.debug(`[${this.name}] ${message}`);
    }
    public info(message: string) {
        this.logger.info(`[${this.name}] ${message}`);
    }
    public warn(message: string) {
        this.logger.warn(`[${this.name}] ${message}`);
    }
    public error(message: string) {
        this.logger.error(`[${this.name}] ${message}`);
    }
}



// WEBPACK FOOTER //
// ./lib_temp/Logger.ts